export * from './defaults';
export * from './store-keys';
export * from './api-base-url';

export const ASSETS_URL = '/assets/images';
export const GUID_EMPTY = '00000000-0000-0000-0000-000000000000';
export const MAX_CARD_VIEW_CONTROLS = 10;
